export default __webpack_public_path__ + "static/media/fundo.5b5282ea.png";